export const AIFC_ONBOARDING_STATE_KEYS = {
	hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
	isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
	hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
	hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
	isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
	hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
	hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
	hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
} as const;

export const AIFCOnboardingKeys = [...Object.values(AIFC_ONBOARDING_STATE_KEYS)] as const;
